import {Directive, HostListener, Input} from '@angular/core';
import {EnvironmentService} from '../services/environment.service';

@Directive({
  selector: '[appStreetNumber]',
})
export class StreetNumberDirective {

  @Input() appStreetNumber: boolean;

  constructor(private environmentService: EnvironmentService) {
  }

  @HostListener('keypress', ['$event']) onKeyPress(event) {
    if (this.appStreetNumber) {
      const charCode = event.key;
      const regexPattern = this.environmentService.regexData.streetNoRegex;
      const numberRegex = new RegExp(regexPattern);
      if (!numberRegex.test(charCode)) {
        event.preventDefault();
      }
      return true;
    }
  }
}
